import guides from './guides';
import faq from './faq';
import products from './products';
import pages from './pages';
import datafields from './datafields';
const content = { ...guides, ...faq, ...products, ...pages, ...datafields };
export default content;
